import type { IntlShape } from "react-intl";

type FormatCurrencyParams = {
  amount: number;
  currency: string;
  excludeDecimals?: boolean;
  intl: IntlShape;
};

/**
 * Formats a price in `currency`. With `excludeDecimals`, whole amounts drop
 * their decimals ("$700") while fractional ones keep them ("$52.25") — the
 * rule mobile's listing cards use. The fraction digits are set explicitly
 * rather than via `trailingZeroDisplay`, which react-intl v2 does not forward.
 */
const formatCurrency = ({
  amount,
  currency,
  excludeDecimals = false,
  intl,
}: FormatCurrencyParams): string =>
  intl.formatNumber(amount, {
    style: "currency",
    currency,
    ...(excludeDecimals && Number.isInteger(amount)
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : {}),
  });

export { formatCurrency };
